'use client'

import Script from 'next/script'

interface AnalyticsProviderProps {
  children: React.ReactNode
}

// Plausible Analytics domain - set via environment variable
const PLAUSIBLE_DOMAIN = process.env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  // Only render analytics script if domain is configured
  const enableAnalytics = !!PLAUSIBLE_DOMAIN

  return (
    <>
      {enableAnalytics && (
        <Script
          defer
          data-domain={PLAUSIBLE_DOMAIN}
          src="https://plausible.io/js/script.js"
          strategy="afterInteractive"
        />
      )}
      {children}
    </>
  )
}
